var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"component",scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slotName){return {key:slotName,fn:function(slotProps){return [_vm._t(slotName,null,null,slotProps)]}}})],null,true)},'component',_vm.mergedAttrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }